
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[ssgParams]/terms",
      function () {
        return require("private-next-pages/[ssgParams]/terms/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[ssgParams]/terms"])
      });
    }
  